var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Transaction") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconography-/-Transaction",
    fill: "#073C50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9813053,0 L8.43425195,2.5433958 L16.9107121,11.0076838 L0,11.0076838 L0,14.9927376 L16.910501,14.9925269 L8.43425195,23.4566042 L10.9813053,26 L24,13 L10.9813053,0 Z M37.0186947,22 L24,35 L37.0186947,48 L39.5657481,45.4566042 L31.089499,36.9925269 L48,36.9927376 L48,33.0076838 L31.0892879,33.0076838 L39.5657481,24.5433958 L37.0186947,22 Z",
    id: "Transaction"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaction);
export default __webpack_public_path__ + "static/media/Transaction.ec29c7cff4597ebb57eddd2ccafad735.svg";
export { ForwardRef as ReactComponent };